import { Layout } from '@/components';
import ApplicationReview from './_components/application-review';
import { useQueryProvider } from '@/hooks';
import { useApi } from '@/api/useApi.tsx';
import React, { useMemo } from 'react';
import { QUERY_KEYS } from '@/constants/QueryKeys.ts';
import LoadingSpinner from '@/components/loading-spinner';

const ApplicationReviewScreen = () => {
	const { ApplicantDocumentControllerApi, ExpertApplicantControllerApi, LiveServiceTypeControllerApi, EducationLevelControllerApi } = useApi();

	const { data: expertApplicantData, isLoading: expertApplicantDataIsLoading } = useQueryProvider(
		[QUERY_KEYS.getLoggedInExpertApplicantDetailInfo],
		() => ExpertApplicantControllerApi.getLoggedInExpertApplicantDetailInfo(),
		{
			select: ({ data }) => data.data,
			refetchOnWindowFocus: false
		}
	);

	const { data: documentsContentType, isLoading: documentsContentTypeIsLoading } = useQueryProvider(
		[QUERY_KEYS.getDocumentsByContentType],
		() => ApplicantDocumentControllerApi.getDocumentsByContentType('VIDEO'),
		{
			select: ({ data }) => data.data,
			refetchOnWindowFocus: false
		}
	);

	const { data: liveServiceTypes, isLoading: liveServiceTypesIsLoading } = useQueryProvider([QUERY_KEYS.getLiveServiceTypes], () => LiveServiceTypeControllerApi.getLiveServiceTypes(), {
		select: ({ data }) => data?.data ?? [],
		refetchOnWindowFocus: false
	});

	const { data: educationLevels = [] } = useQueryProvider([QUERY_KEYS.getEducationLevels], () => EducationLevelControllerApi.getEducationLevels(), {
		select: ({ data }) => data?.data ?? [],
		refetchOnWindowFocus: false
	});

	const expertApplicantIdToName = useMemo(() => {
		if (!educationLevels || !Array.isArray(educationLevels)) {
			return {};
		}

		return educationLevels.reduce((acc, item) => {
			if (item && item.name && item.id) {
				acc[item.id] = item.description;
			}
			return acc;
		}, {});
	}, [educationLevels]);

	const serviceTypeIdToName = useMemo(() => {
		if (!liveServiceTypes || !Array.isArray(liveServiceTypes)) {
			return {};
		}

		return liveServiceTypes.reduce((acc, item) => {
			if (item && item.name && item.id) {
				acc[item.id] = item.description;
			}
			return acc;
		}, {});
	}, [liveServiceTypes]);

	return (
		<Layout>
			<ApplicationReview
				{...expertApplicantData}
				serviceTypeIdToName={serviceTypeIdToName}
				expertApplicantIdToName={expertApplicantIdToName}
				educationLevels={educationLevels}
				documentsContentType={documentsContentType}
			/>

			{expertApplicantDataIsLoading || documentsContentTypeIsLoading || (liveServiceTypesIsLoading && <LoadingSpinner loadingText={'Yükleniyor'} />)}
		</Layout>
	);
};

export default ApplicationReviewScreen;
